export interface DeliveryDates {
  delivery_dates: string[];
  message: string;
  status?: number;
  statusText?: string;
  url?: string;
}

export interface DeliveryDatesRequest {
  offer_reference: string;
  post_code: string;
  supplier_id: number;
  cat_num: string;
  service_cat_numbers: string[] | null;
}

export interface OfferDeliveryDates {
  data: DeliveryDates;
  supplier_id: number;
  cat_num: string;
}
